import React, { ChangeEvent, HTMLProps } from 'react';
import Linkify from 'react-linkify';
import { targetBlankDecorator } from "../../utils/LinkifyDecorator";

interface PropType {
    name: string;
    value: string | null | undefined;
    placeholder?: string;
    hint?: string;
    linkifyHint?: boolean;
    onChangeHandler: (value: any, name: string) => void;
}

const InputText = (props: HTMLProps<HTMLInputElement> & PropType) => {
    const { value, placeholder, name, onChangeHandler, hint, linkifyHint, ...otherProps } = props;
    return (
        <>
            <input
                type="text"
                value={value ? value : ''}
                onChange={(e: ChangeEvent<any>) => { onChangeHandler(e.currentTarget.value, name); }}
                className="form-control"
                placeholder={placeholder}
                name={name}
                {...otherProps}
            />
            {hint && (<span className="form-text m-b-none">{linkifyHint === true ? <Linkify componentDecorator={targetBlankDecorator}>{hint}</Linkify> : hint}</span>)}
        </>
    );
};

export default InputText;



// WEBPACK FOOTER //
// ./src/components/Form/InputText.tsx